import { Component } from '@angular/core';
import { EgiPage, EgiPagesSnapshot } from '@ervo/page-framework';
import { FieldType } from '@ngx-formly/core';
import { genericAppIndexId } from '@/app/egi.pages/app-root.pages/page-ids';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'app-egi-page-select',
    templateUrl: './egi-page-select.component.html',
    styleUrls: ['./egi-page-select.component.css'],
    standalone: false
})
export class EgiPageSelectComponent extends FieldType {
  constructor(private readonly snapshot: EgiPagesSnapshot) {
    super();
  }

  readonly pages: EgiPage[] = this.getPages();

  getPages(): EgiPage[] {
    const pagesClone = cloneDeep(this.snapshot.pages);
    const genericIndexPageIndex = pagesClone.findIndex(a => a.config.id === genericAppIndexId);
    const genericIndexPage = pagesClone[genericIndexPageIndex];

    pagesClone.splice(genericIndexPageIndex, 1);

    return [
      genericIndexPage,
      ...pagesClone.sort((a, b) => (a.config.name > b.config.name ? 1 : -1))
    ];
  }
}
